import { CurrencyTokenTypeERC20, useCurrencyContext } from '@apeiron/currency'
import { NextImage } from '@apeiron/temp'
import { Box, List, ListItemButton, styled } from '@mui/material'
import CustomDropdown, {
  CustomDropdownPopover
} from '@src/components/apostles/bounty/CustomDropdown'

const CurrencyIcon = styled(NextImage)`
  height: 24px;
  width: 24px;
  aspect-ratio: 1;
`

const StyledDropdown = styled(CustomDropdown)`
  background: transparent;
`

const StyledList = styled(List)`
  padding: 0;
  margin: 0;
`

const StyledListItemButton = styled(ListItemButton)`
  border-radius: 0px;
`

const StyledPopover = styled(CustomDropdownPopover)`
  .MuiPaper-root {
    border-radius: 0px;
    width: 160px;
    background: #333;
  }
`

const CurrencyContent = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 8px;
`

const BountyCurrencyDropdown = ({
  value,
  onChange,
  disabled,
  options
}: Props) => {
  const { getCurrency } = useCurrencyContext()

  return (
    <StyledDropdown
      disabled={disabled}
      PopoverComponent={StyledPopover}
      renderDropdownContent={({ closeDropdown }) => {
        return (
          <StyledList>
            {options
              .filter(c => c !== value)
              .map(currencyType => {
                const currency = getCurrency(currencyType)

                return (
                  <StyledListItemButton
                    key={currencyType}
                    onClick={() => {
                      onChange(currencyType)
                      closeDropdown()
                    }}
                  >
                    <CurrencyContent>
                      <CurrencyIcon src={currency?.image} />
                      {currencyType}
                    </CurrencyContent>
                  </StyledListItemButton>
                )
              })}
          </StyledList>
        )
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <span className='token'>{value}</span>
    </StyledDropdown>
  )
}

type Props = {
  value: CurrencyTokenTypeERC20
  disabled?: boolean
  options: CurrencyTokenTypeERC20[]
  onChange: (value: CurrencyTokenTypeERC20) => void
}

export default BountyCurrencyDropdown
